import React from "react";
import { IconButton } from "@material-ui/core";
import Close from "@material-ui/icons/Close";
import { useStyles, ActionButton, CustomTooltip } from "./styles";
import InfoIcon from "material-ui/svg-icons/action/info-outline";

export interface IListTableSelect {
    isOpen: boolean;
    onCloseClick: () => void;
    selectedIds: string[];
    actionHandlers: IListTableHandlers[];
    children?;
    hasSearchBar?: boolean;
}

export interface IListTableHandlers {
    label: string;
    handler: (any) => void;
    dataTest: string;
    icon?;
    disabled?;
    tooltipMessage?;
}

export const ListTableSelect: React.FC<IListTableSelect> = ({
    isOpen,
    onCloseClick,
    selectedIds = [],
    actionHandlers,
    children,
    hasSearchBar,
}) => {
    const classes = useStyles();

    const actions = React.useMemo(() => {
        return (
            <div className="actionButtons">
                {actionHandlers.map((actionHandler, index) => {
                    const button = (
                        <ActionButton
                            data-test={actionHandler.dataTest}
                            key={`${actionHandler.label}${index}`}
                            onClick={() => {
                                actionHandler.handler(selectedIds);
                            }}
                            disabled={actionHandler.disabled || false}
                        >
                            {actionHandler.icon}
                            {actionHandler.label}
                            {actionHandler?.tooltipMessage && actionHandler.disabled && (
                                <InfoIcon className={classes.tooltipIcon} />
                            )}
                        </ActionButton>
                    );

                    return actionHandler.tooltipMessage && actionHandler.disabled ? (
                        <CustomTooltip key={`tooltip-${index}`} title={actionHandler.tooltipMessage} arrow>
                            <div style={{ display: "inline-block" }}>{button}</div>
                        </CustomTooltip>
                    ) : (
                        button
                    );
                })}
            </div>
        );
    }, [selectedIds, actionHandlers]); // eslint-disable-line react-hooks/exhaustive-deps

    if (selectedIds.length == 0 || !isOpen) {
        return <div />;
    }

    if (hasSearchBar) {
        return (
            <div className={classes.selectBox}>
                {children}
                <div className="actionsWithSearch">
                    <div className="counterWithSearch">{selectedIds.length}</div>
                    <span className="itemsSelected">Items Selected</span>
                    <div className="buttonGroup">
                        {actions}
                        <div>
                            <IconButton onClick={onCloseClick} aria-label="delete">
                                <Close />
                            </IconButton>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={classes.selectBox}>
            <div className="counter">{selectedIds.length}</div>
            <span className="itemsSelected">Items Selected</span>
            <div className="buttonGroup">
                {actions}
                <div>
                    <IconButton onClick={onCloseClick} aria-label="delete">
                        <Close />
                    </IconButton>
                </div>
            </div>
        </div>
    );
};
